import React                  from 'react';
import { Observe }            from 'rewire-core';
import { createColumn }       from 'rewire-grid';
import IconButton             from '@material-ui/core/IconButton';
import RefreshIcon            from '@material-ui/icons/Refresh';
import { makeStyles }         from '@material-ui/core/styles';
import { StyleType }          from '../utility/styles';
import MainContentToolbar     from '../main-navigation/MainContentToolbar';
import Breadcrumbs            from '../main-navigation/Breadcrumbs';
import { createGridSettings } from './DefaultSettingsView';
import GridLayout             from './GridLayout';
import Loader                 from '../ui/Loader';
import SettingsModel          from './SettingsModel';
import { useCardStyle }       from './UdfEditor';
import Button                 from '@material-ui/core/Button';
import Icon                   from '@material-ui/core/Icon';
// import SettingsDialog         from './SettingsDialog';

const [apiGridModel, pOldSelectCells] = createGridSettings([
  // createColumn('checked', '',  {type: 'none', renderer: CheckedIconRenderer, editable: true, width: '5%' }),
  createColumn('id',   'Token', {type: 'text', width: '100px', align: 'left', readOnly: true, tooltip: 'For security reasons, we show only the first 8 characters of your API tokens here.'}),
  createColumn('name', 'Name',  {type: 'text', width: '180px', align: 'left', readOnly: true}),
]);

const useItemsPanelViewStyles = makeStyles(theme => ({
  left: {
    display: 'flex',
    flex: '0 0 auto',
    alignItems: 'center',
    overflow: 'auto',
    justifyContent: 'flex-start',
  },
  right: {
    display: 'flex',
    flex: '0 0 auto',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginBottom: '7px',
  },

  addButton: {
    textTransform: 'none',
    minWidth: '0px',
    flex: '0 0 auto',
    marginRight: '10px',
    '&:last-child': {
      marginRight: '0px',
    }
  },

  deleteButton: {
    textTransform: 'none',
    minWidth: '0px',
    flex: '0 0 auto',
    marginRight: '10px',
    '& .material-icons': {
      // '&:hover': {
        color: theme.palette.error.main
      // }
    },
    '&:last-child': {
      marginRight: '0px',
    },
  },
}));

const APISettingsItemsPanelView = ({settings, refresh, classes}: {settings: SettingsModel & {deleteItem?: any; canDeleteItem?: any}, refresh: () => void, classes?: StyleType<typeof useCardStyle>}) => {
  const itemsClasses = useItemsPanelViewStyles();

  return (
    <>
      <MainContentToolbar>
        <div className={itemsClasses.left}>
          <Breadcrumbs />
        </div>
        <div className={itemsClasses.right}>
          <Observe render={() =>
            <>
              <Button className={itemsClasses.addButton} variant='contained' onClick={settings.addItem} disabled={!settings.canAddItem()}>
                <Icon className='add'>{'add'}</Icon>
                Generate New Api Token
              </Button>
              <Button className={itemsClasses.deleteButton} variant='contained' onClick={settings.deleteItem} disabled={!settings.canDeleteItem()}>
                <Icon className='delete'>{'delete'}</Icon>
                Delete Api Token
              </Button>
            </>
            } />
          <IconButton onClick={refresh} aria-label='Refresh'>
            <RefreshIcon />
          </IconButton>
        </div>
      </MainContentToolbar>

      <Observe render={() => (
        <Loader loading={settings.isLoading}>
          <>
            <Observe render={() => (
              <GridLayout settings={settings} classes={classes} grid={apiGridModel} oldSelect={pOldSelectCells} />
            )} />
          </>
        </Loader>
      )} />
    </>
  );
};

export default APISettingsItemsPanelView;
